import type { ComponentType, CSSProperties } from 'react'
import { useRecoilState } from 'recoil'
import { useTranslation } from 'react-i18next'
import { formFieldKeys } from '@messenger/consts'
import { editCaseFieldSelector } from 'atoms'
import { TextArea as RawTextArea } from 'components'

const MESSAGE_ROWS = 6

// The shared TextArea is an untyped JS forwardRef component; type the props
// this field passes it (a [value, setValue] tuple as `value`).
type CaseTextAreaProps = {
  margin?: string
  width?: string
  style?: CSSProperties
  label: string
  value: [string, (value: string) => void]
  rows: number
  'data-testid': string
}
const TextArea = RawTextArea as unknown as ComponentType<CaseTextAreaProps>

type M3FamilyAppreciationMessageProps = {
  margin?: string
  width?: string
}

// The shared textarea is width 100% with padding; border-box keeps the
// padding inside the panel instead of past its edge.
const TEXTAREA_STYLE: CSSProperties = { boxSizing: 'border-box' }

/**
 * The family's thank-you message for the stationery, stored as plain text
 * with its line breaks. M3-only: callers render it behind useIsM3Order.
 */
export const M3FamilyAppreciationMessage = ({
  margin,
  width,
}: M3FamilyAppreciationMessageProps) => {
  const { t } = useTranslation()
  const [message, setMessage] = useRecoilState(
    editCaseFieldSelector({
      name: formFieldKeys.familyAppreciationMessage,
      path: 'value',
    }),
  )

  return (
    <TextArea
      margin={margin}
      width={width}
      style={TEXTAREA_STYLE}
      label={t('caseDetails.tabs.serviceInfo.familyAppreciationMessage')}
      value={[message ?? '', setMessage]}
      rows={MESSAGE_ROWS}
      data-testid="family-appreciation-message"
    />
  )
}
